var clamp = function (a, min, max) {
  if (a < min) {
    return min;
  } else if (a > max) {
    return max;
  }
  return a;
};
export default clamp;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/esm/clamp.js
// module id = 62
// module chunks = 0